/**
 * Version: V0.0.3.0
 * Created: 2026-06-12
 * Updated: 2026-06-13
 * Description: Reusable brand logo component for Dentiefy, matching template styling.
 */

import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export default function Logo({ color = 'text-brand-purple-dark dark:text-white', isMinimized = false, size = 40 }) {
  const { t } = useLanguage();

  return (
    <div className={`flex items-center ${color}`}>
      {/* Brand logo SVG icon */}
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 429.000000 402.000000"
        preserveAspectRatio="xMidYMid meet"
        style={{ width: `${size}px`, height: `${size}px` }}
        className={`${!isMinimized ? 'me-2' : ''}`}
        fill="currentColor"
        stroke="none"
      >
        <g
          transform="translate(0.000000,402.000000) scale(0.100000,-0.100000)"
          fill="currentColor"
          stroke="none"
        >
          <path d="M965 3964 c-296 -66 -472 -297 -532 -694 -12 -83 -14 -156 -10 -345 6 -252 21 -387 71 -618 26 -117 143 -564 152 -579 8 -13 177 -9 327 7 419 44 866 158 1260 321 125 51 138 59 133 78 -28 104 -38 188 -33 286 7 131 25 200 81 315 117 236 336 391 606 427 255 34 534 -83 701 -295 l39 -49 0 49 c0 93 1 93 99 93 147 0 286 -46 331 -110 45 -64 36 -131 -32 -235 l-40 -60 38 35 c55 53 112 145 120 196 12 84 -32 156 -127 204 -62 32 -182 61 -286 68 l-98 7 -7 105 c-13 202 -71 391 -162 529 -202 304 -591 364 -1077 166 -144 -59 -351 -164 -344 -174 8 -14 164 -76 240 -97 50 -13 107 -18 201 -18 73 -1 130 -4 128 -8 -10 -16 -157 -40 -249 -40 -176 -1 -231 19 -615 219 -296 155 -505 221 -720 229 -90 3 -144 -1 -195 -12z m255 -208 c0 -2 -35 -25 -77 -50 -209 -123 -307 -246 -387 -487 -19 -57 -44 -158 -56 -224 -12 -66 -25 -138 -29 -160 l-8 -40 -8 58 c-14 104 0 373 24 462 59 224 198 380 382 429 49 13 159 22 159 12z" />
          <path d="M2942 3020 c-114 -30 -207 -84 -293 -170 -183 -182 -241 -443 -154 -693 13 -39 21 -75 17 -78 -4 -4 -71 -35 -150 -69 -604 -260 -1277 -415 -1731 -397 -229 9 -349 49 -408 136 -54 80 -12 197 122 340 55 60 48 59 -35 -5 -72 -55 -180 -167 -218 -227 -16 -26 -38 -76 -47 -112 -30 -111 -1 -198 90 -267 61 -46 130 -74 255 -101 126 -27 424 -29 615 -3 502 68 1078 255 1531 498 l93 49 63 -51 c264 -214 642 -196 879 41 212 212 253 556 97 816 -73 123 -222 241 -358 284 -97 31 -272 36 -368 9z m270 -131 c100 -21 175 -63 252 -141 112 -114 156 -218 156 -368 -1 -253 -182 -468 -430 -510 -243 -41 -496 118 -570 358 -25 81 -27 225 -4 303 74 251 341 412 596 358z" />
          <path d="M2983 2792 c-101 -36 -182 -111 -223 -206 -11 -27 -19 -51 -17 -53 2 -2 17 17 33 43 41 65 131 129 216 155 169 52 351 -17 451 -171 33 -52 28 -22 -10 53 -33 66 -97 128 -168 162 -77 38 -202 45 -282 17z" />
          <path d="M2456 1700 c-351 -174 -768 -317 -1147 -394 -181 -37 -380 -66 -452 -66 -77 0 -77 2 -13 -202 111 -355 236 -651 340 -807 119 -177 243 -246 318 -174 71 67 105 179 148 482 17 119 40 261 51 316 60 300 173 526 292 584 165 80 326 -73 416 -393 38 -134 62 -265 96 -511 34 -250 51 -323 94 -408 64 -125 129 -134 241 -30 134 123 290 425 419 808 53 157 233 776 228 782 -2 1 -23 -7 -47 -18 -249 -121 -555 -95 -775 65 -27 20 -54 36 -60 35 -5 0 -72 -31 -149 -69z" />
        </g>
      </svg>
      {!isMinimized && <span className="text-2xl font-bold font-sans">{t('nav_brand')}</span>}
    </div>
  );
}
